<template>
  <div class="case-base-family-case-page col-block flex-start">
    <div class="case-base-family-case-search-container row-block">
      <div class="case-base-family-case-search-block input-group" :style="{ width: '280px' }">
        <dataTag
          :style="{ width: '100%' }"
          :disabled="false"
          :placeholder="$t('COMPONENT.case.baseFamilyCase.___searchPlaceholder')"
          :needInfo="false"
          :allowEmpty="true"
          :tagHeight="'200px'"
          :init="query['case']"
          :data="tag['case']"
          :filter="data => !addedCaseIDs.includes(data.case_id) && (data.id !== $route.params.id)"
          :tagDisplay="tag => tag.case_id"
          :emptyMsg="''"
          :replace="(tag, content) => tag.case_id"
          @input="content => { query['case'] = content }"
          @tag="tag => { query['case'] = tag.case_id; curTag['case'] = tag }"
          @send="content => addTag('case')"
        ></dataTag>
        <img :src="require('../../assets/images/search-solid.svg')" alt="">
      </div>
      <button type="button" class="main-button circle-button" :disabled="!query['case'] || !(tag['case'].items || []).length || !curTag['case']" @click="e => addTag('case', 'button')">
        <span>{{ $t('COMMON.button.___add') }}</span>
      </button>
    </div>
    <template v-if="tags['case'].length">
      <div :style="{ height: '10px' }"></div>
      <div class="case-base-family-case-result-container col-block width-full">
        <div class="custom-table" :class="{ 'auto-height': true }">
          <div
            v-if="tableWidths"
            class="table-field col-block grab-container"
            :style="{ width: tableWidths.reduce((s, c) => s + c.value, 0) + 'px' }"
            @mousedown.left="e => boardEvent('board1', e, [boardStart])"
            @mousemove="e => boardEvent('board1', e, [boardMove])"
            @mouseout="e => boardEvent('board1', e, [boardMove])"
            @mouseup.left="e => boardEvent('board1', e, [boardEnd])"
          >
            <!-- line -->
            <div class="grab-line x min" :style="lineData.x.min && lineData.x.min.display ? { left: lineData.x.min.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line x max" :style="lineData.x.max && lineData.x.max.display ? { left: lineData.x.max.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line x main" :style="lineData.x.main && lineData.x.main.display ? { left: (lineData.x.main.base + lineData.x.main.grab) + 'px', display: 'block' } : {}"></div>
            <div class="grab-line x custom" :style="lineData.x.custom && lineData.x.custom.display ? { left: lineData.x.custom.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line y min" :style="lineData.y.min && lineData.y.min.display ? { top: lineData.y.min.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line y max" :style="lineData.y.max && lineData.y.max.display ? { top: lineData.y.max.value + 'px', display: 'block' } : {}"></div>
            <div class="grab-line y main" :style="lineData.y.main && lineData.y.main.display ? { top: (lineData.y.main.base + lineData.y.main.grab) + 'px', display: 'block' } : {}"></div>
            <div class="grab-line y custom" :style="lineData.y.custom && lineData.y.custom.display ? { top: lineData.y.custom.value + 'px', display: 'block' } : {}"></div>
            <!-- /line -->
            <div class="table-container col-block">
              <div class="thead">
                <div class="tr row-block">
                  <div
                    v-for="(option, index) in tableOptions"
                    :key="index"
                    class="th row-block"
                    :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                    :style="{ width: tableWidths[index].value + tableWidths[index].grab + 'px' }"
                    @click="e => !sort.disabled && option.sortMap !== null && tableSortBy(option.sortValue || option.value)"
                  >
                    <template v-if="option.value === '_SELECT'">
                      <img class="select-icon" :src="selectedCaseIDs.length ? selectedCaseIDs.length === tags['case'].length ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-minus.svg') : require('../../assets/images/checkbox-false.svg')" alt="" @click="e => (selectedCaseIDs = selectedCaseIDs.length === tags['case'].length ? [] : tags['case'].map(data => data.id))">
                    </template>
                    <template v-else>
                      <span class="ellipsis">{{ option.title }}</span>
                      <span v-if="option.alert" :style="{ color: '#FA3D3D' }">*</span>
                    </template>
                    <template v-if="option.sortMap !== null">
                      <div :style="{ width: '5px' }"></div>
                      <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true"></i>
                    </template>
                    <!-- <div
                      v-if="index + 1 > staticTableWidths[0].length && tableOptions[index + 1 + staticTableWidths[1].length]"
                      class="grab-box grab-x"
                      :class="{ grabbing: boardData['board1'].grabID === index }"
                      :grab-id="index"
                      :grab-type="'x' + { line: '', grab: '*' }[boardType['board1']]"
                      :grab-x-min="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + (option.minWidth || tableMinWidths) + '*'"
                      :grab-x-max="tableWidths.reduce((s, c) => s + c.value, 0) - tableOptions.slice(index + 1, tableOptions.length - staticTableWidths[1].length).reduce((s, c) => s + (c.minWidth || tableMinWidths), 0) - staticTableWidths[1].reduce((s, c) => s + c, 0) + '*'"
                      :grab-x-custom="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + { line: '', grab: '*' }[boardType['board1']]"
                    ></div> -->
                  </div>
                </div>
              </div>
            </div>
            <div ref="custom-table-scroll" class="table-group-container col-block width-full">
              <div class="col-block">
                <div class="table-container col-block" v-for="(group, gindex) in tableDatas" :key="gindex">
                  <div class="tbody">
                    <div class="tr group row-block" :class="{ selected: false }" :style="group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' }">
                      <a class="container-block row-block">
                        <div class="bar"></div>
                        <div
                          v-for="(option, index) in tableOptions"
                          :key="index"
                          class="td row-block"
                          :class="(option.class || (() => []))(group[option.gValue], gindex, group)"
                          :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                        >
                          <template>
                            <span
                              :style="(option.gstyle || (() => ({})))(group[option.gValue], gindex, group)"
                              :title="((option.gdisplay || (x => x))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')"
                              v-html="(option.gdisplay || (x => x))(group[option.gValue], gindex, group) || option.gempty || ''"
                            ></span>
                          </template>
                          <template v-if="option.sortMap !== null && (option.class || (() => []))(group[option.gValue], gindex, group).includes('center') && !(option.class || (() => []))(group[option.gValue], gindex, group).includes('auto-width')">
                            <div :style="{ width: '5px' }"></div>
                            <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                          </template>
                        </div>
                      </a>
                    </div>
                    <div class="tr col-block" :class="{ selectable: false, selected: false, error: errorCases.find(caseData => caseData.id === data.id) }" v-for="(data, dindex) in group.datas" :key="dindex">
                      <a class="container-block row-block" :style="{ flex: 1 }" @click="e => false && (selectedTableData = data)">
                        <div class="bar"></div>
                        <div
                          v-for="(option, index) in tableOptions"
                          :key="index"
                          class="td row-block"
                          :class="(option.class || (() => []))(data[option.value], dindex, data)"
                          :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                        >
                          <template v-if="option.value === '_SELECT'">
                            <img class="select-icon" :src="selectedCaseIDs.includes(data.id) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')" alt="" @click="e => (selectedCaseIDs = selectedCaseIDs.includes(data.id) ? selectedCaseIDs.filter(id => id !== data.id) : selectedCaseIDs.concat([data.id]))">
                          </template>
                          <template v-else-if="option.value === '_TYPE'">
                            <div class="case-base-family-case-type-list-container row-block">
                              <div class="case-base-family-case-type-list-block row-block">
                                <div class="case-base-family-case-type-container row-block" v-for="(option, toindex) in typeOptions" :key="toindex" @click="e => data.sample_type = option.value">
                                  <img class="select-icon" :src="data.sample_type === option.value ? require('../../assets/images/radio-true.svg') : require('../../assets/images/radio-false.svg')" alt="">
                                  <div class="case-base-family-case-type-title" v-html="option.title"></div>
                                </div>
                              </div>
                              <div :style="{ flex: 1 }"></div>
                            </div>
                          </template>
                          <template v-else-if="option.value === '_RELATION'">
                            <div class="case-base-family-case-relation-container input-group col-block width-full">
                              <select v-model="data.relation" :style="data.relation ? {} : { color: '#A9A9A9' }" @change="e => errorCases = errorCases.filter(caseData => caseData.id !== data.id)">
                                <option value="" disabled>{{ $t('COMPONENT.case.baseFamilyCase.table.option.relation.___placeholder') }}</option>
                                <option v-for="(option, froindex) in familyRelationOptions" :key="froindex" :hidden="addedRelations.includes(option.value) && (data.relation !== option.value)" :value="option.value">{{ $t(option.title) }}</option>
                              </select>
                            </div>
                          </template>
                          <template v-else>
                            <span
                              :style="(option.style || (() => ({})))(data[option.value], dindex, data)"
                              :title="((option.display || (x => x))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                              v-html="(option.display || (x => x))(data[option.value], dindex, data) || option.empty || '- -'"
                            ></span>
                          </template>
                          <template v-if="option.sortMap !== null && (option.class || (() => []))(data[option.value], dindex, data).includes('center') && !(option.class || (() => []))(data[option.value], dindex, data).includes('auto-width')">
                            <div :style="{ width: '5px' }"></div>
                            <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                          </template>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getFamilyCases } from '../../api'
import dataTag from '../tool/dataTag.vue'
import responsitive from '../../mixins/responsitive.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import customGrab from '../../mixins/customGrab.vue'
import { groupBy, sortData } from '../../constants/global/util'
import { familyRelationOptions } from '../../constants/global/data'

export default {
  components: {
    dataTag
  },
  mixins: [
    responsitive,
    toastMethods,
    customGrab
  ],
  props: {
    mode: {
      type: String,
      required: true
    },
    defaultData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      caseData: {},
      tags: {
        case: []
      },
      selectedCaseIDs: [],
      errorCases: [],
      familyMemberLimit: 9,
      // search
      map: {
        case: {}
      },
      query: {
        case: ''
      },
      tag: {
        case: {}
      },
      curTag: {
        case: null
      },
      loading: {
        case: false,
        caseAdd: false
      },
      searchTimer: {
        case: []
      },
      // table
      search: '',
      selectedTableData: null,
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [
        [
          50
        ],
        [
          240,
          300
        ]
      ],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    }
  },
  computed: {
    tableDatas () {
      let tableDatas = []
      tableDatas = [...this.tags['case']]
      tableDatas = sortData(
        tableDatas,
        this.sort.value.map(x => this.sortMap[x]),
        this.sort.order.map(x => x.replace('-', ''))
      )
      tableDatas = groupBy(tableDatas, () => 'default').map(datas => ({ title: datas[0].group, isGroup: true, datas: datas }))
      return tableDatas
    },
    sortMap () {
      return this.tableOptions.reduce((s, c) => ({ ...s, ...{ [c.value]: c.sortMap || c.value } }), {})
    },
    addedCaseIDs () {
      return this.tags['case'].map(tag => tag.case_id)
    },
    tagGroupData () {
      return groupBy(this.tags['case'], tag => tag.relation, true)
    },
    addedRelations () {
      return this.familyRelationOptions.filter(option => (option.limit !== null) && (this.tagGroupData[option.value]) && (this.tagGroupData[option.value].length >= option.limit)).map(option => option.value)
    },
    sendData () {
      return this.tags['case'].filter(data => this.selectedCaseIDs.includes(data.id)).map(data => ({
        id: data.id,
        case_id: data.case_id,
        phenotype: {
          'Affected': 2,
          'Unaffected': 1
        }[data.sample_type],
        relation: data.relation
      }))
    },
    // static
    tableOptions () {
      return [
        {
          value: '_SELECT',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.case.baseFamilyCase.table.title.___case_id'),
          value: 'case_id',
          class: () => []
        },
        {
          title: this.$t('COMPONENT.case.baseFamilyCase.table.title.___type'),
          value: '_TYPE',
          class: () => ['auto-width'],
          alert: true,
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.case.baseFamilyCase.table.title.___relation'),
          value: '_RELATION',
          class: () => ['auto-width', 'no-padding'],
          alert: true,
          sortMap: null
        }
      ]
    },
    typeOptions () {
      return [
        {
          title: this.$t('COMPONENT.case.baseFamilyCase.table.option.type.title.___Affected'),
          value: 'Affected'
        },
        {
          title: this.$t('COMPONENT.case.baseFamilyCase.table.option.type.title.___Unaffected'),
          value: 'Unaffected'
        }
      ]
    },
    // global
    familyRelationOptions () { return familyRelationOptions }
  },
  watch: {
    'defaultData' () {
      this.init()
    },
    'sendData': {
      handler: function (nv) {
        this.$emit('change', nv)
      },
      deep: true
    },
    // search
    'query.case' (nv) {
      this.getCase(nv, 'case')
    },
    // table
    'selectedTableData' (nv, ov) {
      if (nv !== ov && JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.selectedTableData = nv ? JSON.parse(JSON.stringify(nv)) : null
      }
    },
    'selectedCaseIDs' (nv, ov) {
      if (nv.length < ov.length) {
        this.tags['case'] = this.tags['case'].filter(data => nv.includes(data.id))
      }
    },
    'tableDatas' () {
      this.getTableOverflow()
    },
    'windowWidth' (nv) {
      this.getTableWidths(nv)
      this.getTableOverflow()
    }
  },
  created () {
    this.getCase('', 'case')
    this.init()
  },
  methods: {
    ...mapActions([
      'setLoadingAction'
    ]),
    init () {
      this.caseData = this.defaultData['case'] || {}
      if ((this.defaultData['analysis'] || {}).fam_analyze) {
        this.tags['case'] = this.defaultData['analysis'].members.map(member => ({
          id: member.id,
          case_id: member.case_id,
          sample_type: { 2: 'Affected', 1: 'Unaffected' }[member.phenotype],
          relation: member.relation
        }))
        this.selectedCaseIDs = this.tags['case'].map(data => data.id)
      } else {
        this.tags['case'] = []
        this.selectedCaseIDs = []
      }
    },
    // search
    async getCase (query, target) {
      const queryMap = {
      }
      query = (queryMap[target] || (x => x))(query)
      if ((this.curTag[target] || {}).case_id !== query) {
        this.tag[target] = {}
        if (this.searchTimer[target]) {
          clearTimeout(this.searchTimer[target])
        }
        this.searchTimer[target] = setTimeout(async () => {
          if (!this.map[target][query]) {
            this.loading[target] = true
            // this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let caseID = this.caseData.id
              let response = await getFamilyCases(caseID, query, config)
              let datas = response.data.data
              this.map[target] = {
                ...this.map[target],
                [query]: {
                  items: datas || []
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
            this.loading[target] = false
            // this.setLoadingAction(false)
          }
          this.tag[target] = this.map[target][query] || {}
        }, 0)
      }
    },
    addTag (target, type) {
      let data = this.curTag[target]
      if (data && !this.loading[target + 'Add']) {
        this.loading[target + 'Add'] = true
        switch (target) {
          case 'case': {
            if (!this.tags[target].some(tag => tag.case_id === data.case_id)) {
              if (this.tags[target].length < this.familyMemberLimit) {
                this.tags[target].push({
                  id: data.id,
                  case_id: data.case_id,
                  sample_type: data.affected ? 'Affected' : 'Unaffected',
                  relation: ''
                  // relation: this.familyRelationOptions.find(option => !this.addedRelations.includes(option.value)).value/
                })
                this.selectedCaseIDs.push(data.id)
                this.curTag[target] = null
                this.query[target] = ''
              } else {
                this.addToast('error', this.$t('COMMON.toast.___familyMemberLimit', { limit: this.familyMemberLimit }))
              }
            }
            break
          }
          default: {}
        }
        this.query[target] = ''
        this.loading[target + 'Add'] = false
      }
    },
    validateSubmit () {
      let emptyRelationDatas = this.tagGroupData[''] || []
      this.errorCases = emptyRelationDatas
      return emptyRelationDatas.length === 0
    },
    // table
    getTableOverflow () {
      setTimeout(() => {
        let scrollContainer = this.$refs['custom-table-scroll']
        if (scrollContainer) {
          this.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight
        }
      })
    },
    getTableWidths (windowWidth) {
      let tableWidth = ['analysis'].includes(this.mode) ? Math.min((windowWidth - this.scrollbarSize) * 0.95, 912) - (20 * 2) - (10 * 2) : 850
      tableWidth = tableWidth - this.staticTableWidths[0].reduce((s, c) => s + c, 0) - this.staticTableWidths[1].reduce((s, c) => s + c, 0)
      let tableWidths = this.tableWidths || [
        ...this.staticTableWidths[0],
        1,
        ...this.staticTableWidths[1]
      ].map(width => ({
        value: width
      }))
      let tableMinWidths = this.tableMinWidths || 0.1
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length)
      let ratio = tableWidth / tableWidths.reduce((s, c) => s + c.value, 0)
      tableWidths = Array.prototype.concat.apply([], [
        this.staticTableWidths[0].map(width => ({
          value: width,
          grab: 0
        })),
        tableWidths.map(width => ({
          value: width.value * ratio,
          grab: 0
        })),
        this.staticTableWidths[1].map(width => ({
          value: width,
          grab: 0
        }))
      ])
      this.tableMinWidths = tableMinWidths * ratio
      this.tableWidths = tableWidths
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
    },
    // grab
    boardResponse (id, type) {
      return {
        'board1': {
          'start': boardData => {
          },
          'move': boardData => {
          },
          'end': boardData => {
          }
        }
      }[id][type]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/baseFamilyCase.vue